import { useMemo } from "react";
import { Box } from "@mui/material";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { LojaPageContainer } from "../common";
import { usePedidosLoja } from "hooks/usePedidosLoja";
import PedidosKpiCards from "./components/PedidosKpiCards";
import PedidosFilters from "./components/PedidosFilters";
import PedidosOrdersGrid from "./components/PedidosOrdersGrid";

/**
 * Listagem gerencial de pedidos da loja.
 * Lógica de dados e paginação: `usePedidosLoja`.
 */
export default function LojaPedidos() {
  const {
    filters,
    setStableFilter,
    setQueryInput,
    page,
    pageSize,
    setPageSize,
    rows,
    total,
    resumo,
    gridLoading,
    refetch,
    onPaginationModelChange,
  } = usePedidosLoja();

  const isFiltered = useMemo(
    () =>
      Boolean(
        filters.query.trim() ||
          filters.status ||
          filters.dataInicio ||
          filters.dataFim
      ),
    [filters]
  );

  return (
    <LojaPageContainer
      title="Pedidos"
      subtitle="Gestão e acompanhamento dos pedidos da loja."
    >
      <PedidosKpiCards resumo={resumo} totalFiltrado={total} isFiltered={isFiltered} />

      <PedidosFilters
        filters={filters}
        pageSize={pageSize}
        total={total}
        onQueryChange={setQueryInput}
        onStableFilterChange={setStableFilter}
        onPageSizeChange={setPageSize}
        onPesquisar={refetch}
      />

      {!gridLoading && total === 0 ? (
        <MDBox
          py={6}
          textAlign="center"
          sx={{
            border: "1px dashed",
            borderColor: "grey.300",
            borderRadius: 2,
            bgcolor: "grey.50",
          }}
        >
          <ShoppingBagOutlinedIcon sx={{ fontSize: 48, color: "grey.400", mb: 1 }} />
          <MDTypography variant="h6" fontWeight="medium" mb={0.5}>
            Nenhum pedido encontrado
          </MDTypography>
          <MDTypography variant="body2" color="text">
            {isFiltered
              ? "Ajuste a busca, as datas ou limpe os filtros de status."
              : "Ainda não há pedidos registrados na loja."}
          </MDTypography>
        </MDBox>
      ) : (
        <Box>
          <PedidosOrdersGrid
            rows={rows}
            total={total}
            page={page}
            pageSize={pageSize}
            loading={gridLoading}
            onPaginationModelChange={onPaginationModelChange}
          />
        </Box>
      )}
    </LojaPageContainer>
  );
}
